import * as React from 'react';

export const ContentContainer: React.FC<{
    justifyContent?: 'start' | 'center' | 'space-between' | 'end' | 'simple-center' | 'left' | 'full-width';
    testId?: string;
    marginleft?: string;
    marginRight?: string;
    paddingTop?: string;
    marginTop?: number;
    minHeight?: string;
}> = (props) => {
    const style: React.CSSProperties = {
        paddingTop: `${props.justifyContent==='full-width' ? '0px' : '16px'}`,
        paddingBottom: 16,
        marginTop: `${props.justifyContent==='full-width' ? '0px' : '16px'}`,
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: props.justifyContent || 'center',
        alignItems: 'stretch',
        marginLeft: props.marginleft || 'auto',
        marginRight: props.marginRight || 'auto',
        minHeight: props.minHeight ? props.minHeight : '90vh',
        position: 'relative',
        overflowX: 'hidden',
    };

    if (!props.justifyContent || props.justifyContent === 'simple-center') {
        return (
            <div data-testid={props.testId} style={{ maxWidth: '1124px', ...style }}>
                <div style={{ flex: '1 1 100%', zIndex: 0 }}>{props.children}</div>
            </div>
        );
    }

    
    if (!props.justifyContent || props.justifyContent === 'full-width') {
        return (
            <div data-testid={props.testId} style={{ maxWidth: '100%', ...style }}>
                <div style={{ flex: '1 1 100%', zIndex: 0 }}>{props.children}</div>
            </div>
        );
    }

    return (
        <div data-testid={props.testId} style={style}>
            {props.children}
        </div>
    );
};
